export default function (container = document) {
  let $elements = container.querySelectorAll('[data-module="expand"]')

  for (let i = 0; i < $elements.length; i++) {
    init($elements[i])
  }
}

function init ($element) {
  let $toggle = $element
  let $target = document.getElementById($element.getAttribute('aria-controls'))
  let isExpanded = $element.getAttribute('aria-expanded') === 'true'

  $toggle.addEventListener('click', function () {
    isExpanded = !isExpanded

    $toggle.setAttribute('aria-expanded', isExpanded)
    if (isExpanded) {
      $target.removeAttribute('hidden')
    } else {
      $target.setAttribute('hidden', '')
    }
  })
}
